<div class="formulaire">
    <div style="margin: 20px 0;">
        <img height="80px" src="assets/ticket.png" style="vertical-align: middle;"/>
        <span style="vertical-align: middle;">{{'Ouvrir un ticket' | translate}}</span>
    </div>
<!--  -->
    <form (ngSubmit)="onSubmit()">
        <mat-form-field class="full-width" appearance="outline">
            <mat-label>{{'Votre nom' | translate}}</mat-label>
            <input [disabled]="lockForm" [(ngModel)]="inforForm.contact" name="societe" autocomplete="off" matInput>
        </mat-form-field>
        <mat-form-field class="full-width" appearance="outline">
            <mat-label>{{'Votre société' | translate}}</mat-label>
            <input [disabled]="lockForm" [(ngModel)]="inforForm.client" name="name" autocomplete="off" matInput>
        </mat-form-field>
        <mat-form-field class="full-width" appearance="outline">
            <mat-label>{{'Numéro de téléphone' | translate}}</mat-label>
            <input [disabled]="lockForm" [(ngModel)]="inforForm.phone" name="phone" autocomplete="off" matInput>
        </mat-form-field>
        <mat-form-field class="full-width" appearance="outline">
            <mat-label>{{'Votre message' | translate}}</mat-label>
            <textarea [disabled]="lockForm" [(ngModel)]="inforForm.message" name="message" matInput rows="10"></textarea>
        </mat-form-field>
        <button mat-raised-button [disabled]="lockForm" type="submit">{{'Envoyer' | translate}}</button>
        <mat-spinner *ngIf="lockForm"></mat-spinner>
    </form>
</div>
